import { MeshPhysicalNodeMaterial } from 'three/webgpu'
import { mx_noise_vec3, normalView, positionWorld, uniform } from 'three/tsl'

export default class GlassMaterial extends MeshPhysicalNodeMaterial {
	static defaults = {
		color: 0xffffff,
		metalness: 0,
		roughness: 0.0,
		transmission: 1,
		transparent: true,
		thickness: 1,
		ior: 1.75,
		dispersion: 3,
		attenuationColor: 0x5a96ff,
		attenuationDistance: 0.8,
		specularIntensity: 1,
		envMapIntensity: 1,
		distortion: 0.02,
		distortionScale: 20,
		temporalDistortion: 0.0,
	}

	constructor(options = {}) {
		const { distortion, distortionScale, temporalDistortion, ...rest } = { ...GlassMaterial.defaults, ...options }

		super(rest)

		this.temporalDistortion = temporalDistortion
		this._time = uniform(0)

		if (distortion > 0) {
			const wobble = mx_noise_vec3(positionWorld.mul(distortionScale).add(this._time), distortion)

			this.normalNode = normalView.add(wobble).normalize()
		}
	}

	set time(value) {
		this._time.value = value * this.temporalDistortion
	}

	get time() {
		return this._time.value
	}
}
